// Import model
import { ReferencedObject } from '../models/ReferencedObject';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for ReferencedObject - handles JSON serialization and deserialization with type validation
 */
export class ReferencedObjectSerializer {
  /**
   * Deserializes a JSON string into a ReferencedObject instance
   */
  static deserialize(json: string): ReferencedObject {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a ReferencedObject instance
   */
  static fromObject(obj: any): ReferencedObject {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to ReferencedObject');
    }


    const instance: ReferencedObject = {
      objectId: obj['objectId'] as string | undefined,
      objectType: obj['objectType'] as string | undefined,
      objectTypeName: obj['objectType|Name'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of ReferencedObject instances
   */
  static deserializeArray(json: string): ReferencedObject[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a ReferencedObject instance to a JSON string
   */
  static serialize(instance: ReferencedObject): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a ReferencedObject instance to a plain object
   */
  static toObject(instance: ReferencedObject): any {
    return {
      'objectId': instance.objectId,
      'objectType': instance.objectType,
      'objectType|Name': instance.objectTypeName,
    };
  }

  /**
   * Serializes an array of ReferencedObject instances to a JSON string
   */
  static serializeArray(instances: ReferencedObject[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
